import { useEffect, useMemo, useState } from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { Loading } from '@icp/components';
import { parseJSON } from '@icp/utils';
import FormRenderer from '@icp/form-renderer';
import { forEachFieldInSchema, isLayout } from '@icp/form-schema';
import { fetchPersonalDashboard, registerFormMethods } from './action';

export default function PersonalDashboard() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [forceRefresh, setForceRefresh] = useState({});
  const [freshSchema, setFreshSchema] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    setLoading(true);
    fetchPersonalDashboard(signal)
      .then((res) => ({
        ...res,
        schema: parseJSON(res.schemaJson) || { fields: [] },
      }))
      .then(setData)
      .finally(() => setLoading(false));

    return () => {
      controller.abort();
    };
  }, [forceRefresh]);

  const noAnyFields = useMemo(() => {
    let res = true;
    forEachFieldInSchema(freshSchema || data?.schema || {}, (field) => {
      if (!isLayout(field)) {
        res = false;
      }
    });
    return res;
  }, [data, freshSchema]);

  if (loading) return <Loading />;
  if (!data) return null;
  return (
    <>
      {noAnyFields && <Empty style={{ marginTop: 44 }} description={t('empty-dashboard')} />}
      <FormRenderer
        context={{ isMainFormRenderer: true, dashboardId: data.id }}
        schema={data.schema}
        onRefreshData={() => setForceRefresh({})}
        onFirstRendered={(formApi) => registerFormMethods(formApi, data.id)}
        onSchemaChanged={setFreshSchema}
      />
    </>
  );
}
